import styled from '@emotion/styled'
import { Stack } from '@mui/system'

export const StyledStackContent = styled(Stack)`
  padding-top: 20px;
  width: calc(100% - 30px);
  height: calc(100vh - 120px);
`
